import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { toast } from "react-toastify";
import WebService from "../../Services/WebService";

interface PropData {
    uuid: string;
  showModal?: boolean;
  title : string
  onCloseModel?: (isClose: boolean) => void;
}

const UserDeleteModal = (props: PropData) => {
  const [loading, setLoading] = useState<boolean>(false);

  const onConfirmDelete = async () => {
    setLoading(true);
      try {
      const res: any = await WebService.postAPI({
        action: `/cancel_subscription_payment`,
        body: { subscription_uuid: props.uuid },
      });

      if (res.success) {
        toast.success("Your plan has been cancelled successfully.");
            setLoading(false);
        closeModal(); // Refresh list
      } else {
        toast.error(res.message || "Failed to cancel subscription.");
         setLoading(false);
      }
    } catch (err: any) {
      toast.error(err?.response?.data?.message || "Error cancelling plan");
       setLoading(false);
    }
  };

  const closeModal = () => {
    props.onCloseModel?.(false);
  };

  return (
    <Modal show={props.showModal} onHide={closeModal} centered>
      <Modal.Header closeButton>
        <Modal.Title className="font-18">{props.title || "Confirmation"}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        <div><IoIosCloseCircleOutline size={70} color="#f15e5e" /></div>
        <div className="font-16 pt-2">Are you sure you want to cancel?</div>
        <p className="text-muted" style={{ fontSize: "14px" }}>Note: After cancellation, your subscription will remain active until the expiry date. Subscription payments are non-refundable.</p>
      </Modal.Body>
      <Modal.Footer className="justify-content-center pt-2 border-top-0">
        <Button variant="outline-primary me-3" onClick={closeModal} disabled={loading}>
          No
        </Button>
        <Button variant="primary" onClick={onConfirmDelete} disabled={loading}>
          Yes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UserDeleteModal;
